var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002457(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    y: 0.0361328,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8731 33.2409C14.8736 33.2409 9.99414 28.3614 9.99414 22.3633C9.99414 16.3653 14.8736 11.4844 20.8731 11.4844C26.8726 11.4844 31.752 16.3639 31.752 22.3633C31.752 28.3628 26.8726 33.2423 20.8731 33.2423V33.2409ZM20.8731 15.7054C17.2022 15.7054 14.2152 18.6925 14.2152 22.3633C14.2152 26.0342 17.2022 29.0213 20.8731 29.0213C24.544 29.0213 27.531 26.0342 27.531 22.3633C27.531 18.6925 24.544 15.7054 20.8731 15.7054Z",
    fill: "url(#paint0_linear_1352_1075)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.487 21.4645L28.2892 12.7171L29.2643 9.93688C29.3558 9.67518 29.5049 9.43881 29.7005 9.24323L33.7118 5.23327C33.785 5.16011 33.9088 5.19528 33.9341 5.29518L34.5968 7.92065C34.6742 8.23019 34.9162 8.47219 35.2244 8.55099L37.6219 9.16725C37.7204 9.19258 37.7542 9.31358 37.6852 9.38675L33.7203 13.5895C33.4895 13.8343 33.1969 14.0102 32.8733 14.1002L30.646 14.7193L22.0675 23.9506C21.8395 24.1955 21.4554 24.2067 21.2134 23.9746L19.4955 22.3213C19.2535 22.0878 19.2507 21.7022 19.4884 21.4659L19.487 21.4645Z",
    fill: "#C284F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1075",
    x1: 29.0444,
    y1: 11.4844,
    x2: 12.7018,
    y2: 33.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D790F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7056DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002457);
export default __webpack_public_path__ + "static/media/Group-1000002457.88cc7352125e755e4c58e94b59450fd2.svg";
export { ForwardRef as ReactComponent };